export default "__VITE_ASSET__DSbwDWpm__"